// src/pages/AssignmentQuizPage.jsx
import React, { useEffect, useState } from "react";
import StaffSidebar from "../components/StaffSidebar";
import axios from "axios";
import "../assets/css/assignments.css";

export default function AssignmentQuizPage() {
  const programme = localStorage.getItem("programme");
  const API = process.env.REACT_APP_API_BASE_URL || "http://localhost:3003";

  const LEVELS = ["ND1", "ND2", "HND1", "HND2", "Postgraduate", "Diploma"];

  // existing items (assignments & quizzes)
  const [items, setItems] = useState([]);

  // form state
  const [type, setType] = useState("assignment");
  const [title, setTitle] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [file, setFile] = useState(null);
  const [level, setLevel] = useState(LEVELS[0]);
  const [courses, setCourses] = useState([]);
  const [courseId, setCourseId] = useState("");

  // fetch existing items
  useEffect(() => {
    axios
      .get(`${API}/api/staff/items`, { params: { programme } })
      .then((res) => setItems(res.data))
      .catch(console.error);
  }, [API, programme]);

  // fetch courses for this programme
  // inside AssignmentQuizPage.jsx

  // 1) In your useEffect, validate the response:
  useEffect(() => {
    axios
      .get(`${API}/api/staff/items`, { params: { programme } })
      .then((res) => {
        // assuming your API returns an array at res.data
        if (Array.isArray(res.data)) {
          setItems(res.data);
        } else if (Array.isArray(res.data.items)) {
          // or maybe it's nested in .items
          setItems(res.data.items);
        } else {
          console.warn("Unexpected items payload:", res.data);
          setItems([]); // fallback
        }
      })
      .catch((err) => {
        console.error(err);
        setItems([]); // on error also fallback
      });
  }, [API, programme]);

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleSubmit = () => {
    if (!title || !dueDate || !courseId) {
      return alert("Please fill title, due date, level and select a course.");
    }

    const form = new FormData();
    form.append("programme", programme);
    form.append("type", type);
    form.append("title", title);
    form.append("dueDate", dueDate);
    form.append("level", level);
    form.append("courseId", courseId);
    if (file) form.append("file", file);

    axios
      .post(`${API}/api/staff/items`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        setItems([res.data, ...items]);
        // reset form
        setType("assignment");
        setTitle("");
        setDueDate("");
        setFile(null);
        setLevel(LEVELS[0]);
        if (courses.length) setCourseId(courses[0].CourseID);
      })
      .catch((err) => {
        console.error(err);
        alert("Failed to create item");
      });
  };

  return (
    <div className="staff-dashboard" style={{ marginTop: "-130px" }}>
      <StaffSidebar />
      <main>
        <h1>Assignments & Quizzes</h1>

        <section className="new-item">
          {/* Type */}
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="assignment">Assignment</option>
            <option value="quiz">Quiz</option>
          </select>

          {/* Title */}
          <input
            type="text"
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          {/* Level */}
          <select value={level} onChange={(e) => setLevel(e.target.value)}>
            {LEVELS.map((lvl) => (
              <option key={lvl} value={lvl}>
                {lvl}
              </option>
            ))}
          </select>

          {/* Course */}
          <select
            value={courseId}
            onChange={(e) => setCourseId(e.target.value)}
          >
            {courses.map((c) => (
              <option key={c.CourseID} value={c.CourseID}>
                {c.CourseCode} – {c.CourseTitle}
              </option>
            ))}
          </select>

          {/* Due Date */}
          <input
            type="date"
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
          />

          {/* File upload */}
          <input type="file" onChange={handleFileChange} />

          {/* Submit */}
          <button onClick={handleSubmit} className="btn-create">
            Create & Send
          </button>
        </section>

        <ul className="item-list">
          {(Array.isArray(items) ? items : []).map((it) => (
            <li key={it.id}>
              <div>
                <strong>[{it.type.toUpperCase()}]</strong> {it.title}
                <br />
                <small>
                  Level: {it.level} | Course: {it.courseCode}
                </small>
              </div>
              <div>
                <span>Due: {new Date(it.dueDate).toLocaleDateString()}</span>
                {it.fileUrl && (
                  <a
                    href={it.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </a>
                )}
              </div>
            </li>
          ))}
          {(Array.isArray(items) ? items : []).length === 0 && (
            <p>No assignments or quizzes sent yet.</p>
          )}
        </ul>
      </main>
    </div>
  );
}
